"use client";
import React from 'react';
import { AbTestingSdk } from '@sravni/ab-testing-sdk/lib/browser';

const DEFAULT_VALUE = new AbTestingSdk({ experiments: {}, statistics: '', userData: {} });
const AbTestingContext = React.createContext(DEFAULT_VALUE);

export { AbTestingContext, DEFAULT_VALUE };
//# sourceMappingURL=Context.js.map
